export default __webpack_public_path__ + "media/images/attachment-c5cccf4da88cdc8c9da83ddf8b4dc1af.svg";